'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var Twine = _interopDefault(require('twine'));
var lazySizes = _interopDefault(require('lazysizes'));
var picturefill = _interopDefault(require('picturefill'));
require('picturefill/dist/plugins/intrinsic-dimension/pf.intrinsic');
var A11yHelpers = _interopDefault(require('../global/a11y-helpers.js'));
var AjaxEmailForm = _interopDefault(require('./ajax-email-form.js'));
var Drawer = _interopDefault(require('./drawer.js'));
var Flash = _interopDefault(require('./flash.js'));
var Nav = _interopDefault(require('./nav.js'));
var Popover = _interopDefault(require('./popover.js'));
var Signup = _interopDefault(require('./signup/signup.js'));
var SocialShareButton = _interopDefault(require('./social-shares-buttons.js'));
var Subscribe = _interopDefault(require('./subscribe.js'));
var CookiesNotice = _interopDefault(require('./cookies-notice.js'));

/* global ShopifyMarketing */

// Legacy apps are expecting instances of drawer, nav, signup, and flash to be available on this object
window.ShopifyMarketing = window.ShopifyMarketing || {};
// Signup uses a global Twine context with several references bound in the DOM
window.ShopifyMarketing.context = window.ShopifyMarketing.context || {};

function init() {
  Twine.reset(ShopifyMarketing.context).bind().refresh();
  picturefill();
  lazySizes.init();
  ShopifyMarketing.drawer = new Drawer('NavDrawer', 'right');
  ShopifyMarketing.nav = new Nav();
  ShopifyMarketing.signup = new Signup();
  ShopifyMarketing.flash = new Flash();
  new A11yHelpers();
  new CookiesNotice();

  $('.js-popover').each(function () {
    new Popover(this);
  });

  $('.js-social-share').each(function () {
    new SocialShareButton(this);
  });

  $('.js-ajax').each(function () {
    new AjaxEmailForm(this);
  });

  $('.js-subscribe').each(function () {
    new Subscribe(this);
  });
}

module.exports = init;
